import * as React from 'react';
const SvgTrendAscent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={19}
    fill="none"
    viewBox="0 0 19 9"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.083 0a.75.75 0 0 0 0 1.5h1.94l-4.44 4.44-4.47-4.47a.75.75 0 0 0-1.06 0L.22 7.303a.75.75 0 1 0 1.06 1.06l5.303-5.302 4.47 4.47a.75.75 0 0 0 1.06 0l4.97-4.97V4.5a.75.75 0 0 0 1.5 0V.75a.75.75 0 0 0-.75-.75z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTrendAscent;
